<div class="datatable-r">
  <div class="DTTT_container">
    <button
      class="DTTT_button btn blue-hoki custombtn"
      id="ToolTables_tblProjects_0"
      tabindex="0"
      aria-controls="tblProjects"
      (click)="saveView()"
    >
      <span [innerHTML]="'Save current view'"></span>
    </button>
  </div>
</div>
